import { queryClient } from "@api/queryClient";
import { useNotificationsSocket } from "@notifications/use-notifications-socket";
import { AuthProvider } from "@providers/AuthProvider";
import { SessionCacheReset } from "@providers/SessionCacheReset";
import { UserProvider } from "@providers/UserProvider";
import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

const NotificationsBridge = () => {
  useNotificationsSocket();
  return null;
};

export const AppProviders = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <UserProvider>
        {/* Must precede `children`: sibling effects run in tree order, so its
            reset lands before a card re-seeds its form from the new payload. */}
        <SessionCacheReset />
        <NotificationsBridge />
        {children}
      </UserProvider>
    </AuthProvider>
  </QueryClientProvider>
);
